import moment from 'moment';

export const getTimestamp = (message) => {
    return moment.unix(message.created_at).format('HH:mm - DD/MM/YY');
};
